import {
  Alert,
  Button,
  Image,
  Pressable,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  KeyboardAvoidingView,
  Platform,
} from "react-native";
import { MaterialIcons, Ionicons, FontAwesome5 } from "@expo/vector-icons";
import { useContext, useEffect, useState } from "react";
import NewCommunity from "./NewCommunity";
import { getCommunity } from "../src/graphql/queries";
import { API, Auth } from "aws-amplify";
import { FlatList, ScrollView, TextInput } from "react-native-gesture-handler";
import { LinearGradient } from "expo-linear-gradient";
import CommunityCard from "../styles/CommunityCard";
import { UserContext } from "../globalData/UserContext";
import { CommunityContext } from "../globalData/ComunityContext";
import { ComNavContext } from "../globalData/ComNavContext";
import JoinCommunity from "./JoinCommunity";
import { globalStyles } from "../styles/globalStyles";
import KeyBoardAvoidingWrapper from "./components/KeyboardAvoidingWrapper";

export default function Communities({ navigation }) {
  const [communityModalOpen, setCommunityModalOpen] = useState(false); // used to check whether the add community page should be shown or not.
  const [joinModalOpen, setJoinModalOpen] = useState(false);
  const [myCommunities, setMyCommunities] = useState(); // the communities that the user is in
  const [filteredCommunities, setFilteredCommunities] = useState();
  const userData = useContext(UserContext); //get the db user from the UserContext
  let user = {};
  if (userData != null) user = userData.user; //set local variable to context user - db user
  const communityData = useContext(CommunityContext);
  const communityNavigation = useContext(ComNavContext);
  const [locationFilter, setLocationFilter] = useState(false);

  // ALL INSTRUCTIONS
  const [instructions, setInstructions] = useState(false); // find a better way to do instructions w/o a bunch of state
  const [plusInstructions, setPlusInstructions] = useState(false);
  const [reloadInstructions, setReloadInstructions] = useState(false);
  const [comInstructions, setComInstructions] = useState(false);

  // retrieves all of the communities the user is in using userCommunities when initially rendered.
  useEffect(() => {
    if (user != null) {
      fetchCommunities();
    }
  }, [user]); // find better method in order to get it to reload.

  async function fetchCommunities() {
    const communities = user.data.getUsers.communities.items;
    // ALSO NECESSARY: no way to access communities underneath a user as userCommunities only has access to community IDs.
    // VK - should we add additional columns in the getUsers query in graphql to avoid call this community
    const userCommunities = await Promise.all(
      communities.map(async (com) => {
        return API.graphql({
          query: getCommunity,
          variables: { cId: com.communityUsersCId },
        });
      })
    );
    const coms = userCommunities.filter(
      (com) => com.data.getCommunity != null && typeof com != "undefined"
    );
    setMyCommunities(coms);
    setFilteredCommunities(coms);
  }

  // displays the welcome message for the user -- only works when user is defined
  function welcomeMessage() {
    if (user != null && user.data.getUsers != null)
      return "Welcome " + user.data.getUsers.userName + "!";
    return "Welcome!";
  }

  function filterCommunities(text) {
    text = text.toLowerCase();
    const nonNullComs = myCommunities.filter(
      (com) => com.data.getCommunity.city != null
    );
    const filteredComs = nonNullComs.filter(
      (com) => com.data.getCommunity.city.toLowerCase().indexOf(text) == 0
    );
    if (text == "") setFilteredCommunities(myCommunities);
    else setFilteredCommunities(filteredComs); // ISSUE: when this is changed it is never reset to the original
    // number of communities -- once all communities don't match, they'll never actually match because
    // they no longer exist in myCommunities (need to refetch/reset/ use another object)
  }
  return (
    <LinearGradient
      colors={["#F3E3D8", "#fcf6f2"]}
      style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
    >
      <Image
        style={
          Platform.OS == "web"
            ? { width: 600, height: 500 }
            : { marginTop: -20 }
        }
        source={require("../assets/bookswap.png")}
      />
      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
          marginTop: -5,
          marginTop: 10,
        }}
      >
        <Text style={styles.titleText}>{welcomeMessage()}</Text>
        <FontAwesome5
          name="user-cog"
          color="#56494c"
          size={25}
          onPress={() => {
            navigation.navigate("MyInfo");
          }}
        />

        {/* <MaterialIcons
          name="info"
          color="#56494c"
          size={30}
          style={{ marginLeft: 10 }}
          onPress={() => {
            setInstructions(true);
          }}
        /> */}
      </View>
      <Text style={styles.text}>
        Click the person icon to join a community or the plus icon to create a
        new one!
      </Text>
      <NewCommunity
        modalOpen={communityModalOpen}
        closeModal={setCommunityModalOpen}
        currUser={user}
        refresh={async () => {
          userData.refreshUser();
          await fetchCommunities();
        }}
      />
      <JoinCommunity
        modalOpen={joinModalOpen}
        setModalOpen={setJoinModalOpen}
        nav={navigation}
        refresh={async () => {
          userData.refreshUser();
          await fetchCommunities();
        }}
      />
      <View
        style={{
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        {/* the filter for the location -- if pressed location filter set to true and search bar displayed */}
        {locationFilter ? (
          <KeyboardAvoidingView
            behavior="position"
            keyboardVerticalOffset={-300}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MaterialIcons
                name="close"
                color="#A48578"
                size={24}
                style={{ marginTop: 10, marginRight: 10 }}
                onPress={async () => {
                  await fetchCommunities();
                  setLocationFilter(false);
                }}
              />
              <TextInput
                style={{
                  ...globalStyles.input,
                  paddingVertical: 10,
                  fontSize: 17,
                  color: "#A48578",
                  marginLeft: 0,
                }}
                placeholder="Search your location"
                placeholderTextColor="#E2CFC2"
                onChangeText={(text) => {
                  filterCommunities(text);
                }}
              />
            </View>
          </KeyboardAvoidingView>
        ) : (
          <View style={{ flexDirection: "column" }}>
            <MaterialIcons
              name="filter-list"
              color="#56494c"
              size={24}
              style={{ ...styles.modalToggle, marginBottom: -5 }}
              onPress={() => {
                setLocationFilter(true);
              }}
            />
            <Text
              style={{
                marginBottom: 5,
                fontFamily: "quicksand-normal",
                color: "#56494c",
              }}
            >
              filter by location
            </Text>
          </View>
        )}
        {instructions && (
          <View style={globalStyles.instructions}>
            <Text style={{ ...globalStyles.paragraph }}>
              Click on the person icon to add yourself to an existing community
              and share books with community members.
            </Text>
            <Button
              title="next"
              onPress={() => {
                setInstructions(false);
                setPlusInstructions(true);
              }}
            />
          </View>
        )}
        {user != null &&
          user.data.getUsers != null &&
          typeof user.data.getUsers.student != "undefined" &&
          !user.data.getUsers.student && (
            <MaterialIcons
              name="person-add"
              color="#56494c"
              size={24}
              style={styles.modalToggle}
              onPress={() => {
                setJoinModalOpen(true);
              }}
            />
          )}
        {plusInstructions && (
          <View style={globalStyles.instructions}>
            <Text style={{ ...globalStyles.paragraph }}>
              Click on the plus icon to create a new community. Add members to
              the community and start sharing books.
            </Text>
            <Button
              title="next"
              onPress={() => {
                setPlusInstructions(false);
                setReloadInstructions(true);
              }}
            />
          </View>
        )}
        {user != null &&
          user.data.getUsers != null &&
          typeof user.data.getUsers.student != "undefined" &&
          !user.data.getUsers.student && (
            <MaterialIcons
              name="add"
              color="#56494c"
              size={24}
              style={styles.modalToggle}
              onPress={() => {
                setCommunityModalOpen(true);
              }}
            />
          )}
        <MaterialIcons
          name="refresh"
          color="#56494c"
          size={24}
          style={styles.modalToggle}
          onPress={async () => {
            userData.refreshUser();
            await fetchCommunities();
            Alert.alert("refreshed!");
          }}
        />
        {reloadInstructions && (
          <View style={globalStyles.instructions}>
            <Text style={{ ...globalStyles.paragraph }}>
              Press the refresh icon to update your community list.
            </Text>
            <Button
              title="next"
              onPress={() => {
                setReloadInstructions(false);
                setComInstructions(true);
              }}
            />
          </View>
        )}
        {comInstructions && (
          <View style={globalStyles.instructions}>
            <Text style={{ ...globalStyles.paragraph }}>
              All the communities you joined will show up below. Click on a
              community to start sharing books.
            </Text>
            <Button
              title="ok"
              onPress={() => {
                setComInstructions(false);
              }}
            />
          </View>
        )}
      </View>
      <FlatList
        data={filteredCommunities}
        renderItem={({ item }) => (
          <TouchableOpacity
            styles={{ flex: 1 }}
            onPress={() => {
              communityData.updateCommunity(item.data.getCommunity);
              navigation.navigate("Drawer");
              communityNavigation.setCommunityNav(navigation);
            }}
          >
            <View styles={{ flex: 1 }}>
              <CommunityCard>
                <Ionicons
                  name="ios-people"
                  color="#56494c"
                  style={styles.iconStyle}
                  size={24}
                />
                <View
                  style={{
                    flexDirection: "column",
                    marginLeft: 50,
                  }}
                >
                  <Text style={styles.communityName}>
                    {item.data.getCommunity.cName}
                  </Text>
                  <Text style={styles.communityLocation}>
                    {item.data.getCommunity.city}
                  </Text>
                </View>
              </CommunityCard>
            </View>
          </TouchableOpacity>
        )}
      />
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          paddingBottom: 60,
          marginTop: 10,
          flexDirection: "row",
        }}
      >
        <View style={styles.bottom}>
          <Text style={styles.buttonText}>in association with OBOC</Text>
        </View>
        <View>
          <Image
            source={require("../assets/OBOCLogo.png")}
            style={styles.logoStyle}
          />
        </View>
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  modalToggle: {
    flexDirection: "row",
    marginBottom: 1,
    borderWidth: 1,
    borderColor: "#f2f2f2",
    padding: 10,
    borderRadius: 10,
    alignSelf: "center",
    marginTop: 10,
  },

  iconStyle: {
    color: "#492C1D",
  },

  titleText: {
    fontFamily: "quicksand-bold",
    fontSize: 30,
    color: "rgba(86, 73, 76, 0.76)",
    marginHorizontal: 15,
  },

  text: {
    marginTop: 10,
    marginHorizontal: 20,
    fontFamily: "quicksand-normal",
    fontSize: 19,
    color: "rgba(86, 73, 76, 0.76)",
  },

  communityName: {
    color: "#A48578",
    fontFamily: "quicksand-normal",
    fontSize: 20,
    fontWeight: "100",
  },

  bottom: {
    justifyContent: "center",
    alignItems: "center",
    height: 40,
    flexDirection: "row",
    // borderWidth: 2,
    // borderColor: "#a48578",
    // borderRadius: 20,
    // width: 140,
    marginBottom: 40,
  },

  buttonText: {
    color: "#A48578",
    fontSize: 20,
    fontFamily: "quicksand-normal",
  },

  communityLocation: {
    fontSize: 15,
    marginTop: 2,
    color: "#56494c",
    fontFamily: "quicksand-bold",
  },
  logoStyle: {
    height: 50,
    width: 50,
    marginLeft: 30,
  },
});
